<script setup lang="ts">
import { CreditItem } from '@/types/apiTypes'
import integralApi from '@/api/integralApi'
import { transformCreditData } from '@/utils/commonUtils'
import { useIntegralStoreHook } from '@/store/modules/integral'
import { Code } from '@/config/httpCode'
const isShow = ref(false)
const tableData = ref<CreditItem[]>([])
const getIntegral = async () => {
  try {
    await useIntegralStoreHook().getIntegralConsumption()
    tableData.value = useIntegralStoreHook().integralArray
  } catch (error) {
    console.error('获取积分消耗列表失败:', error)
  }
}
onMounted(async () => {
  await getIntegral()
})

const close = () => {
  isShow.value = false
}
const open = () => {
  isShow.value = true
}
defineExpose({
  open,
  close,
})
</script>
<template>
  <el-dialog
    v-model="isShow"
    width="50%"
    append-to-body
    modal-class="global-mask"
    :modal="true"
    :show-close="false"
    :close-on-click-modal="true"
    :close-on-press-escape="true"
    class="custom-dialog"
    top="10vh"
  >
    <el-card class="mt-4" :body-style="{ padding: '20px' }" shadow="never" style="border: none">
      <template #header>
        <div class="flex justify-between items-center">
          <h2 class="text-size20 text-[#000]">计费规则</h2>
        </div>
      </template>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="消耗积分项">
          <template #default="{ row }">
            <span v-copy="row.name">{{ row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="count" label="积分">
          <template #default="{ row }">
            <span>{{ row.count }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="unit" label="单位">
          <template #default="{ row }">
            <el-text class="mx-1 !text-[#0770ED]">{{ row.unit }}</el-text>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述">
          <template #default="{ row }">
            <span v-copy="row.description">{{ row.description }}</span>
          </template></el-table-column
        >
      </el-table>
      <div class="flex items-center justify-center mt-[20px]">
        <div
          class="font-roboto px-[50px] py-[7px] bg-home-aisound-btn rounded-[25px] text-size16 text-white mt-[30px] hover-transition"
          @click="close"
        >
          关闭
        </div>
      </div>
    </el-card>
  </el-dialog>
</template>

<style scoped>
.custom-dialog :deep(.el-dialog) {
  border-radius: 8px;
  overflow: hidden;
  margin-top: 0 !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
  border: none;
}

.custom-dialog :deep(.el-dialog__header) {
  display: none;
}

.custom-dialog :deep(.el-dialog__body) {
  padding: 0;
  overflow: hidden;
}

.custom-dialog :deep(.el-dialog__footer) {
  display: none;
}

.custom-dialog :deep(.el-card__body) {
  overflow: hidden;
}

.custom-dialog :deep(.el-table__body-wrapper),
.custom-dialog :deep(.el-scrollbar) {
  overflow: hidden !important;
}
</style>
